import { FormEvent, useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { useClientContext } from 'client/context';
import { UserReset } from 'client/voladeum/auth/types';
import { updateSettings } from 'ducks/settings/slices';
import { Icon } from 'framework/Icon';
import { PUBLIC } from 'router/routes';
import { useAppDispatch } from 'store/hooks';

import { PasswordConfirmation } from './components/PasswordConfirmation';
import { PasswordReset } from './components/PasswordReset';
import { user_reset_default } from './defaults';

import cn from './PasswordRequestPage.module.scss';

export default () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [is_success, setSuccess] = useState(false);

  const [form, setForm] = useState<UserReset>({ ...user_reset_default });
  const { Voladeum } = useClientContext();

  const onChange = useCallback(
    (user: Partial<UserReset>) => setForm((prev) => ({ ...prev, ...user })),
    []
  );

  const onSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        const payload: UserReset = { login: form.login };
        await Voladeum.auth.forgotPassword(payload);
      } catch (err) {
        console.error(err);
      } finally {
        setSuccess(true);
      }
    },
    [form.login, Voladeum.auth, setSuccess]
  );

  const resendEmail = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        dispatch(updateSettings({ loading: true }));
        const payload: UserReset = { login: form.login };
        await Voladeum.auth.resendEmail(payload);
      } catch (err) {
        console.error(err);
      } finally {
        setTimeout(() => dispatch(updateSettings({ loading: false })), 2000);
      }
    },
    [dispatch, form.login, Voladeum.auth]
  );

  return (
    <div className={cn.page}>
      <div className={cn.container}>
        {is_success ? (
          <PasswordConfirmation resendEmail={resendEmail} />
        ) : (
          <PasswordReset form={form} onChange={onChange} onSubmit={onSubmit} />
        )}
        <a className={cn.back} onClick={() => navigate(PUBLIC.LOGIN.path)}>
          <Icon icon={faArrowLeft} size="14px" width="30px" />
          Sign in
        </a>
      </div>
    </div>
  );
};
